export const generateId = (prefix) => {
    const randomNumber = Math.floor(Math.random() * 1000);
    return `${prefix}-${randomNumber}`;
};
//# sourceMappingURL=generateId.js.map